import { all, call, select, put, takeLatest } from "redux-saga/effects";
import * as jsonpatch from "fast-json-patch";
import { FETCH_SERVICE_BY_USERID, fetchServiceByUserIdFailure, fetchServiceByUserIdSuccess,
  fetchServiceByUserIdRequested, FETCH_PRODUCT_BY_USERID, fetchProductByUserIdRequested,
  fetchProductByUserIdFailure, fetchProductByUserIdSuccess, ADD_SERVICE_PRODUCT, UPDATE_SERVICE_BY_USERID,
  updateProductByUserIdRequested, updateProductByUserIdFailure, updateProductByUserIdSuccess,
  addServiceProductRequested, addServiceProductFailure, addServiceProductSuccess, fetchProductByUserId,
  GET_ACCEPTED_DELIVERED, getAcceptedDeliveredRequested, getAcceptedDeliveredSuccess, getAcceptedDeliveredFailure,
  GET_FAVOURITE_BUSINESS, getFavouriteBuisnessSuccess, getFavouriteBuisnessRequested, getFavouriteBuisnessFailure,
  ADD_FAVOURITE_BUSINESS, addFavouriteBuisnessSuccess, addFavouriteBuisnessRequested, addFavouriteBuisnessFailure,
  addUnFavouriteBuisnessRequested, addUnFavouriteBuisnessFailure, addUnFavouriteBuisnessSuccess, ADD_UN_FAVOURITE_BUSINESS,
  getFavouriteBuisness, GET_RECOMMENDED_SERVICE, getRecommendedServiceFailure, getRecommendedServiceRequested,
  getRecommendedServiceSuccess }
  from "../actions/market-action-types";
import httpClient from "./http-client";

export function* fetchServiceByUserIdHandler(req = null) {
  yield put(fetchServiceByUserIdRequested());
  const userData = yield select((state) => state?.user?.user);
  const userId = userData?.identifier;

  const params = { type: "Service" };

  if (req.payload === undefined) {
    params.userId = userId;
  } else {
    params.type = req.payload?.type;
    params.category = req.payload?.categories;
    params.name = req.payload?.name;
  }

  const request = {
    method: "GET",
    url: "/api/v1/marketplace",
    params,
  };
  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(fetchServiceByUserIdFailure(error));
  } else {
    yield put(fetchServiceByUserIdSuccess(data.details));
  }
}

export function* fetchProductByUserIdHandler(req = null) {
  yield put(fetchProductByUserIdRequested());
  let params = {};
  const userData = yield select((state) => state?.user?.user);
  const userId = userData?.identifier;

  if (req.payload == null) {
    params = {
      userId, type: "Product",
    };
  } else if (req?.payload?.type === "allBuissness") {
    params = {};
  } else {
    params = { userId };
  }

  const request = {
    method: "GET",
    params,
    url: "/api/v1/marketplace",
  };
  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(fetchProductByUserIdFailure(error));
  } else {
    yield put(fetchProductByUserIdSuccess(data.details));
  }
}

// Function to update the product
export function* updateProductByUserHandler({ payload }) {
  yield put(updateProductByUserIdRequested());
  const bussinessData = yield select((state) => state?.market?.productData);
  const updatedData = bussinessData.find((x) => x.identifier === payload?.identifier);
  const update = {
    ...updatedData, ...payload,
  };
  const result = jsonpatch.compare(updatedData, update);
  const request = {
    method: "Patch",
    url: `/api/v1/marketplace/${payload?.identifier}`,
    data: { payload: result },
  };

  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(updateProductByUserIdFailure(error));
  } else {
    yield put(updateProductByUserIdSuccess(data));
    yield put(fetchProductByUserId({ payload: "" }));
  }
}

// Function to add product/service
export function* addServiceProductHandler({ payload }) {
  yield put(addServiceProductRequested());
  const userData = yield select((state) => state?.user?.user);
  const userId = userData.identifier;
  const request = {
    data: {
      payload: {
        type: payload.type,
        userId,
        name: payload.name,
        category: payload.category,
        serviceArea: payload.serviceArea,
        description: payload.description,
        coverImage: payload.coverImage,
        cost: payload.cost,
        quote: payload.quote,
        questions: payload.questions,
        measureUnit: payload.measureUnit,
        recurring: payload.recurring,
        fortnightly: payload.fortnightly,
        quantity: payload.quantity,
        createdBy: payload.createdBy,
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
    },
    method: "POST",
    url: "/api/v1/marketplace",
  };

  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(addServiceProductFailure(error));
  } else {
    yield put(fetchProductByUserId({ payload: userId }));
    yield put(addServiceProductSuccess(data));
  }
}

export function* getAcceptedDeliveredHandler() {
  yield put(getAcceptedDeliveredRequested());
  const userData = yield select((state) => state?.user?.user);
  const userId = userData?.identifier;

  const params = { userId };

  const request = {
    method: "GET",
    params,
    url: "/api/v1/status/jobs",
  };
  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(getAcceptedDeliveredFailure(error));
  } else {
    yield put(getAcceptedDeliveredSuccess(data.details));
  }
}

export function* getFavouriteBuisnessHandler({ payload }) {
  yield put(getFavouriteBuisnessRequested());
  const userData = yield select((state) => state?.user?.user);

  let userId = userData?.identifier;

  if (payload?.userId) {
    userId = payload?.userId;
  }
  const params = {
    userId,
    type: "Task",
  };

  const request = {
    method: "GET",
    params,
    url: "/api/v1/favourties",
  };
  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(getFavouriteBuisnessFailure(error));
  } else {
    yield put(getFavouriteBuisnessSuccess(data.details));
  }
}

export function* addFavouriteBuisnessHandler(req = null) {
  yield put(addFavouriteBuisnessRequested());
  const userData = yield select((state) => state?.user?.user);
  const userId = userData?.identifier;

  const request = {
    data: {
      payload: {
        userId,
        type: "Task",
        itemId: req?.payload?.taskId,
        meta: { },
      },
    },
    method: "POST",
    url: "/api/v1/favourties",
  };
  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(addFavouriteBuisnessFailure(error));
  } else {
    yield put(addFavouriteBuisnessSuccess(data.details));
    yield put(getFavouriteBuisness());
    yield put(fetchProductByUserId({ type: "allBuissness" }));
  }
}

export function* addUnFavouriteBuisnessHandler(req = null) {
  yield put(addUnFavouriteBuisnessRequested());

  const request = {
    method: "DELETE",
    url: `/api/v1/favourties/${req?.payload}`,
  };
  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(addUnFavouriteBuisnessFailure(error));
  } else {
    yield put(addUnFavouriteBuisnessSuccess(data.details));
    yield put(getFavouriteBuisness());
    yield put(fetchProductByUserId({ type: "allBuissness" }));
  }
}

export function* getRecommendedServiceHandler() {
  yield put(getRecommendedServiceRequested());
  const userData = yield select((state) => state?.user?.user);
  const userIdentifier = userData?.identifier;

  const params = { userId: userIdentifier };

  const request = {
    method: "GET",
    url: "/api/v1/recommend",
    params,
  };
  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(getRecommendedServiceFailure(error));
  } else {
    yield put(getRecommendedServiceSuccess(data.details));
  }
}

function* Market() {
  yield all([
    takeLatest(FETCH_SERVICE_BY_USERID, fetchServiceByUserIdHandler),
    takeLatest(FETCH_PRODUCT_BY_USERID, fetchProductByUserIdHandler),
    takeLatest(ADD_SERVICE_PRODUCT, addServiceProductHandler),
    takeLatest(UPDATE_SERVICE_BY_USERID, updateProductByUserHandler),
    takeLatest(GET_ACCEPTED_DELIVERED, getAcceptedDeliveredHandler),
    takeLatest(GET_FAVOURITE_BUSINESS, getFavouriteBuisnessHandler),
    takeLatest(ADD_FAVOURITE_BUSINESS, addFavouriteBuisnessHandler),
    takeLatest(ADD_UN_FAVOURITE_BUSINESS, addUnFavouriteBuisnessHandler),
    takeLatest(GET_RECOMMENDED_SERVICE, getRecommendedServiceHandler),
  ]);
}
export default Market;
